import { Component, OnInit } from '@angular/core';
import { LeadService } from '../../../../../../shared/store/lead/lead.service';
import { filter, Observable } from 'rxjs';
import {
  BaseLeadFormModel,
  LeadDetailModel,
} from '../../../../../../shared/store/lead/types';
import { Entity } from '../../../../../../shared/store/view/types';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { take } from 'rxjs/operators';
import { formatDate } from '../../../../../../shared/helper/datehelper';
import { ReferralCampaign } from '../../../../../../shared/store/campaign/types';
import {
  removeValidators,
  setValidators,
} from '../../../../../../shared/helper/formhelper';
import { debugLog } from '../../../../../../shared/pipe/rxjs/operators';

@Component({
    selector: 'app-lead-form-marketing',
    templateUrl: './lead-form-marketing.component.html',
    styleUrls: ['./lead-form-marketing.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class LeadFormMarketingComponent implements OnInit {
  leadDetail$: Observable<LeadDetailModel>;
  baseLeadFormModel$: Observable<BaseLeadFormModel>;
  leadForm: FormGroup<any>;
  isCampaignReferral: boolean = false;
  protected readonly Entity = Entity;
  constructor(
    private readonly leadService: LeadService,
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.leadDetail$ = this.leadService.getByUniqueId.value$;
    this.baseLeadFormModel$ = this.leadService.getBaseLeadModel.value$;

    this.leadForm = this.parent.form;
    this.leadForm.addControl(
      'marketingFormGroup',
      this.formBuilder.group({
        marketingCampaignId: [undefined, [Validators.required]],
        marketingMediumId: [undefined],
        marketingSourceId: [undefined],
        marketingCreationDate: [''],
        marketingReferrerId: [undefined],
      })
    );

    this.baseLeadFormModel$.pipe(filter((x) => !!x)).subscribe((x) => {
      this.leadForm.patchValue({
        marketingFormGroup: {
          marketingSourceId: x.leadFormModel.sourceId,
          marketingCampaignId: x.leadFormModel.campaignId,
          marketingMediumId: x.leadFormModel.mediumId,
        },
      });
    });

    this.leadDetail$
      .pipe(
        filter((x) => !!x),
        take(1)
      )
      .subscribe((x) => {
        this.leadForm.patchValue({
          marketingFormGroup: {
            marketingCampaignId: x.campaignId,
            marketingMediumId: x.mediumId,
            marketingSourceId: x.sourceId,
            marketingCreationDate: formatDate(
              x.creationDate,
              'ToInverseSqlDate'
            ),
            marketingReferrerId: x.contactReferrerId,
          },
        });
      });

    this.leadForm.controls['marketingFormGroup']
      .get('marketingCampaignId')
      ?.valueChanges.subscribe((x) => {
        if (x == ReferralCampaign) {
          this.isCampaignReferral = true;

          setValidators(
            this.leadForm.controls['marketingFormGroup'].get(
              'marketingReferrerId'
            ),
            Validators.required
          );
        } else {
          this.isCampaignReferral = false;

          removeValidators(
            this.leadForm.controls['marketingFormGroup'].get(
              'marketingReferrerId'
            ),
            Validators.required
          );
        }
      });
  }
}
